import script from "./TextCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TextCard.vue?vue&type=script&setup=true&lang=js"

import "./TextCard.vue?vue&type=style&index=0&id=af966540&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af966540"]])

export default __exports__